module.exports = __webpack_public_path__ + "static/media/ipad.d4e8d777.png";